export const events = {
    // from internal components
    onSystemEvent: 'OnSystemEvent',
    onSocketDataReceived: 'SystemSocketDataReceived',

    onTimeChanged: 'ClockVue_TimeUpdated',
    onReconnected: 'onReconnected',
    onClearCache: 'onClearCache',

    // from service
    onJournalUpdated: 'OnJournalUpdated',
    onQuotaUpdated: 'OnQuotaUpdated',
    onQuotaDeleted: 'OnQuotaDeleted',
};
